import React from 'react';
import { Link } from 'react-router-dom';

const ResourcesCTA = () => {
  return (
    <div
      className="text-center rounded-[30px] border-2 border-icetex/20"
      style={{
        background: 'linear-gradient(135deg, #e8f4ff 0%, #d4e9ff 100%)',
        padding: '50px 40px',
      }}
    >
      <h3 className="text-texto-oscuro font-extrabold mb-4 text-[2rem]">
        Continúa Explorando
      </h3>
      <p className="text-texto-sec mb-[30px] text-[1.1rem]">
        Descubre más herramientas y oportunidades en nuestra plataforma
      </p>
      <div className="flex justify-center flex-wrap gap-5">
        <Link
          to="/diagnosticos"
          className="font-bold cursor-pointer no-underline uppercase inline-block rounded-full text-white bg-gradient-to-br from-icetex to-icetex-dark px-[40px] py-4 text-[1rem] tracking-[0.5px] hover:-translate-y-[3px] transition-all duration-300"
          style={{ boxShadow: '0 6px 20px rgba(0, 63, 129, 0.3)' }}
        >
          Herramientas de Diagnóstico
        </Link>
        <a
          href="https://moodle.cursosvirtualesicetex.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold cursor-pointer no-underline uppercase inline-block rounded-full text-icetex bg-white border-2 border-icetex px-[40px] py-4 text-[1rem] tracking-[0.5px] hover:bg-icetex hover:text-white hover:-translate-y-[3px] transition-all duration-300"
        >
          Plataforma de Formación
        </a>
      </div>
    </div>
  );
};

export default ResourcesCTA;
